import { EventEmitter } from 'events'

export default class Evented extends EventEmitter {
  protected internalEventListeners: Array<{target: EventEmitter, event: string, handler: any}> = []

  public listenTo (target: EventEmitter, event: string, handler: (...args: any) => void) {
    this.internalEventListeners.push({ target, event, handler })
    target.on(event, handler)
  }

  public stopListening (target?: EventEmitter, event?: string, handler?: (...args: any) => void) {
    let i = 0
    while (i < this.internalEventListeners.length) {
      const listener = this.internalEventListeners[i]
      if (
        (!target || listener.target === target) &&
            (!event || listener.event === event) &&
            (!handler || listener.handler === handler)
      ) {
        listener.target.removeListener(listener.event, listener.handler)
        this.internalEventListeners.splice(i, 1)
      } else {
        i++
      }
    }
  }
}
